import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "liga-float-bar signup-float-bar" }
const _hoisted_2 = { class: "main-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border events-page-header liga-float-header signup-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "signup-float-toolbar" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "liga-float-circle",
                  "aria-label": "Назад",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('login')))
                }, [
                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "liga-float-title-pill" }, [
                  _createElementVNode("span", { class: "liga-float-title-text" }, "Регистрация")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("div", {
                  class: "liga-float-spacer",
                  "aria-hidden": "true"
                }, null, -1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background",
        fullscreen: true,
        "scroll-y": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "signup-card bg-transparent" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_input, {
                    type: "email",
                    inputmode: "email",
                    placeholder: "Электронная почта",
                    modelValue: _ctx.registerAccount.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerAccount.email) = $event)),
                    disabled: _ctx.loading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_ion_input, {
                    type: "text",
                    placeholder: "Имя",
                    modelValue: _ctx.registerAccount.firstName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerAccount.firstName) = $event)),
                    disabled: _ctx.loading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_ion_input, {
                    type: "text",
                    placeholder: "Фамилия",
                    modelValue: _ctx.registerAccount.lastName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerAccount.lastName) = $event)),
                    disabled: _ctx.loading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_ion_input, {
                    type: "password",
                    placeholder: "Пароль",
                    modelValue: _ctx.registerAccount.password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerAccount.password) = $event)),
                    disabled: _ctx.loading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_ion_input, {
                    type: "password",
                    placeholder: "Пароль еще раз",
                    modelValue: _ctx.confirmPassword,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                    disabled: _ctx.loading
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.singUp())),
                      class: "signup-button",
                      disabled: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("p", null, "Регистрация", 512), [
                          [_vShow, !_ctx.loading]
                        ]),
                        _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                          [_vShow, _ctx.loading]
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}